module.exports = __webpack_public_path__ + "static/media/amrit.4c0ad86d.png";